import {
  collection,
  deleteDoc,
  doc,
  getDocs,
  query,
  where,
} from 'firebase/firestore';

export function buildEmailCampaignActionUrl(teamId = '', campaignId = '') {
  if (!teamId || !campaignId) return '';
  return `/teams/${encodeURIComponent(teamId)}?emailCampaign=${encodeURIComponent(campaignId)}`;
}

export function isEmailReplyNotification(note = {}) {
  const actionUrl = typeof note?.actionUrl === 'string' ? note.actionUrl.trim() : '';
  const dedupeKey = typeof note?.dedupeKey === 'string' ? note.dedupeKey.trim() : '';
  return actionUrl.includes('emailCampaign=') || dedupeKey.startsWith('email-reply:');
}

export async function clearEmailReplyNotification({ db, userId, notificationId }) {
  if (!db || !userId || !notificationId) return 0;
  await deleteDoc(doc(db, 'notifications', userId, 'items', notificationId));
  return 1;
}

export async function clearEmailReplyNotificationsForCampaign({ db, userId, teamId, campaignId }) {
  const actionUrl = buildEmailCampaignActionUrl(teamId, campaignId);
  if (!db || !userId || !actionUrl) return 0;

  const notificationsQuery = query(
    collection(db, 'notifications', userId, 'items'),
    where('actionUrl', '==', actionUrl)
  );
  const snap = await getDocs(notificationsQuery);
  await Promise.all(snap.docs.map((noteDoc) => (
    deleteDoc(doc(db, 'notifications', userId, 'items', noteDoc.id))
  )));
  return snap.docs.length;
}
